import moment from "moment";
import React from "react";
import Slider from "react-slick";
import { DropdownList } from "react-widgets";
import { htmlDecode } from "../../core";
import { Project, PropertyDetails } from "../../core/api/models/project";
import SplitMerge from "./SliptMerge";
import Spinner from "../../components/loader/spinner";

interface ProjectOverviewBasicDetailsProps {
    isSpliting?: boolean;
    splitUnitsAndProperties?: (
        propertyId: string,
        unitId: string,
        splitPropertyDetails: any[]
      ) => void;
    canAddTenancyOrLease: any;
    findMinDate: (values: any[]) => string;
    floorData: { value: any; label: string; total: any; }[];
    handleClickpopup: () => void;
    isShown: boolean;
    mainSlider: [any, React.Dispatch<any>][number];
    onRemove: (unitID: string) => void;
    onSelect: (unitID: string) => void;
    openDeveloperTab: (e: React.MouseEvent<HTMLSpanElement, MouseEvent>, developerId: string) => void;
    project?: Project | undefined
    renderSelectItems: ({ item }: any) => JSX.Element;
    isMerging?: boolean;
    selectedOption: [any, React.Dispatch<any>][number];
    setIsShown: React.Dispatch<React.SetStateAction<boolean>>;
    setMainSlider: React.Dispatch<any>;
    setSelectedOption: React.Dispatch<any>;
    setShowAddOption: React.Dispatch<React.SetStateAction<boolean>>;
    setShowAddSingleOption: React.Dispatch<React.SetStateAction<boolean>>;
    setThumbSlider: React.Dispatch<any>;
    showAddOption: boolean;
    showAddSingleOption: boolean;
    mergePropeties?: () => void;
    showDetailsOnly?: boolean;
    allUnit?: number;
    thumbSlider: [any, React.Dispatch<any>][number];
    unitData: any;

    selectedProperty?:any
    availableUnit?: number;
    settings: {
        className: string;
        dots: boolean;
        infinite: boolean;
        slidesToShow: number;
        slidesToScroll: number;
    };
    thumbSettings:{
        className: string;
        dots: boolean;
        infinite: boolean;
        slidesToShow: number;
        slidesToScroll: number;
        variableWidth: boolean;
        arrows: boolean;
        focusOnSelect: boolean;
    }
}


export function ProjectOverviewBasicDetails({ canAddTenancyOrLease,
    findMinDate,
    floorData,
    handleClickpopup,
    isShown,
    mainSlider,
    onRemove,
    onSelect,
    openDeveloperTab,
    renderSelectItems,
    selectedOption,
    setIsShown,
    setMainSlider,
    setSelectedOption,
    setShowAddOption,
    setShowAddSingleOption,
    setThumbSlider,
    showAddOption,
    showAddSingleOption,
    thumbSlider,
    unitData,
    mergePropeties,
    settings,
    splitUnitsAndProperties,
    showDetailsOnly,
    availableUnit,
    allUnit,
    selectedProperty,
    isMerging,
    project,
    isSpliting,
    thumbSettings }: ProjectOverviewBasicDetailsProps) {
    return (
        <div className="row mb-3">
            <div className="col-md-6 col-12 pl-0 pr-5">
                <Slider
                    {...settings}
                    asNavFor={thumbSlider}
                    ref={(slider) => setMainSlider(slider)}
                >
                    {project?.resImages?.map((img) => {
                        return (
                            <img
                                src={`https://cf-cdn.cityinfoservices.com/public/uploads/project/images/large/${img.projectImageName}`}
                                alt={img.projectImageAltTag}
                                className="img-cover rounded"
                            />
                        );
                    })}
                </Slider>
                <Slider
                    {...thumbSettings}
                    asNavFor={mainSlider}
                    ref={(slider) => setThumbSlider(slider)}
                >
                    {project?.resImages?.map((img) => {
                        return (
                            <div style={{ width: "88px" }}>
                                <img
                                    src={`https://cf-cdn.cityinfoservices.com/public/uploads/project/images/small/${img.projectImageName}`}
                                    alt={img.projectImageAltTag}
                                    className="img-cover mr-2 w-100"
                                />
                            </div>
                        );
                    })}
                </Slider>
            </div>
            <div className="col-md-6 col-12 px-0">
                <div className="d-flex align-items-center">
                    <h2 className="flex-fill pr-3 font-xxl mb-1 font-weight-semibold">
                        {project?.projectName}
                    </h2>
                    <div
                        className={
                            selectedProperty?.length
                                ? "border border-primary px-1 px-2 py-1 selectproperty-ico font-md align-items-center rounded-lg d-flex justify-content-center "
                                : ""
                        }
                        style={{
                            width: selectedProperty?.length ? "60px" : "",
                        }}
                    >
                        {selectedProperty && (
                            <span
                                className="font-xxl text-primary mr-1"
                                style={{ height: "30px" }}
                            >
                                {selectedProperty?.length || ""}
                            </span>
                        )}
                        <svg
                            width="23"
                            height="20"
                            viewBox="0 0 25 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                id="Vector"
                                d="M20.7748 0.846845C18.0794 -0.593747 14.5243 -0.156234 12.2903 1.85387C10.0454 -0.154626 6.48464 -0.587461 3.79831 0.846845C1.45711 2.0882 0 4.4655 0 7.04673C0 7.78581 0.12279 8.52021 0.340012 9.15287C1.48591 14.1129 8.84221 20.64 12.2903 20.64C15.7309 20.64 23.0816 14.1123 24.2078 9.23692C24.4493 8.51948 24.5725 7.78683 24.5725 7.046C24.5727 4.4655 23.1169 2.08732 20.7748 0.846845ZM22.5345 8.76258C21.4683 13.3786 14.5215 18.8996 12.2903 18.8996C9.80714 18.8996 3.0414 13.1158 2.01347 8.67867C1.82987 8.14351 1.74157 7.59563 1.74157 7.04775C1.74157 5.1122 2.84172 3.32341 4.61223 2.38435C5.43668 1.94275 6.37457 1.71486 7.32268 1.71486C8.99146 1.71486 10.5623 2.4228 11.6338 3.6602L12.2979 4.42019L12.952 3.6602C14.6207 1.72377 17.6859 1.16698 19.9642 2.38435C21.7347 3.32341 22.835 5.1122 22.835 7.04775C22.8314 7.59461 22.7425 8.14263 22.5345 8.76258Z"
                                fill={
                                    selectedProperty?.length ? "#4161c8" : "#0F1312"
                                }
                            />
                        </svg>
                    </div>
                </div>
                {!!project?.projectBuilderName && <div className="d-flex font-sm align-items-center mb-3 pb-1">
                    <span
                        role="button"
                        className="text-gray-800"
                        onClick={(e) =>
                            openDeveloperTab(
                                e,
                                project?.projectBuilderName || ""
                            )
                        }
                    >
                        by {project?.projectBuilderName}
                    </span>

                </div>}
                <div className="d-flex font-sm align-items-center mb-2 text-gray-800">
                    <span className="text-gray-500 mr-1">Project Type:</span>{" "}
                    {project?.projectTypeName}
                </div>
                <div className="d-flex font-sm align-items-center mb-2 text-gray-800 pb-1">
                    <i className="icon-location-filled mr-2 text-gray-500"></i>
                    {htmlDecode(project?.projectAddress1!)}
                </div>
                {!showDetailsOnly && (
                    <div className="mb-4 pb-1">
                        <div className="font-normal text-gray-800 border rounded-pill d-inline-flex py-1 px-2 align-items-center mr-2">
                            <b>{String(availableUnit).padStart(2, "0")}</b> /
                            {String(allUnit).padStart(2, "0")}
                            Matching
                        </div>
                        <div className="font-normal text-gray-600 border rounded-pill d-inline-flex py-1 px-2 align-items-center mr-2">
                            Unit matching :{" "}
                            <span className="text-gray-800">
                                {String(availableUnit).padStart(2, "0")}
                            </span>
                        </div>
                        <div className="font-normal text-gray-600 border rounded-pill d-inline-flex py-1 px-2 align-items-center mr-2">
                            Floor matching :{" "}
                            <span className="text-gray-800">
                                {String(availableUnit).padStart(2, "0")}
                            </span>
                        </div>
                    </div>
                )}
                {project?.properties?.some(property => property.priceOnReq?.toLowerCase() === 'yes') ?
                    <div className="border-bottom pb-2 mb-4">
                        <h3 className="mb-0">Price On Request</h3>
                    </div>
                    : project?.pricePerSqft &&
                    (project?.rentUnitCount > 0 ||
                        project?.sellUnitCount > 0) && (
                        <div className="border-bottom pb-2 mb-4">
                            <h3 className="mb-0">₹ {project?.pricePerSqft}</h3>
                            <div className="font-sm text-gray-500">Per Sq. Ft</div>
                        </div>
                    )}

                <div className="row mt-3">
                    {project?.attributes?.map((attr) => {
                        return (
                            <div className="col-md-4 col-6 mb-4">
                                <div className="border-bottom pb-3">
                                    <div className="font-sm text-gray-500 mb-1">
                                        {attr.attrName}
                                    </div>
                                    <div className="mb-0 font-sm font-weight-semibold text-gray-800">
                                        {attr.attrOptionValue}
                                    </div>
                                </div>
                            </div>
                        );
                    })}

                </div>

                <div className="pt-2">

                    {!showAddOption &&
                        !showDetailsOnly &&
                        canAddTenancyOrLease && (
                            <button className="btn btn-primary font-weight-bold font-normal rounded">
                                <span
                                    className="px-md-3"
                                    onClick={() => {
                                        setShowAddOption(true);
                                        // if (!selectedProperty?.length) {
                                        setShowAddSingleOption(true);
                                        // }
                                    }}
                                >
                                    <i className="icon-plus-sm mr-3 pr-1 font-xs"></i>
                                    Add Options
                                </span>
                            </button>
                        )}
                </div>

                <div className="mt-4 pt-1">

                    {showAddOption && canAddTenancyOrLease && (
                        <>
                            <h5 className="font-weight-semibold my-2 py-1">Options</h5>
                            {!!selectedProperty?.length && (
                                <table className="table table-bordered w-100 font-sm">
                                    <thead>
                                        <tr className="bg-gray-100">
                                            <th colSpan={2}>
                                                <span className="d-inline-flex align-items-center">
                                                    Option
                                                </span>
                                            </th>
                                            <th>
                                                <span className="d-inline-flex align-items-center">
                                                    Total Area(sq.ft) :
                                                </span>{" "}
                                                {selectedProperty?.reduce(
                                                    (t: any, c: any) => t + Number(c.area || 0),
                                                    0
                                                ) || 0}
                                            </th>
                                            <th>
                                                <span className="d-inline-flex align-items-center">
                                                    Available From :{" "}
                                                </span>
                                                {findMinDate(selectedProperty)}

                                            </th>
                                            <th></th>
                                        </tr>
                                        <tr>
                                            <td>Floor</td>
                                            <td>Unit</td>
                                            <td>Area</td>
                                            <td>Date From</td>
                                            <td></td>
                                        </tr>{" "}
                                        {selectedProperty?.map(
                                            (up: PropertyDetails) => (
                                                <tr>
                                                    <td>{up.floor}</td>
                                                    <td>{up.unitName}</td>
                                                    <td>{up.area}</td>
                                                    <td>
                                                        {up?.availableFrom &&
                                                            up?.availableFrom !==
                                                            "1970-01-01T00:00:00.000Z" && (
                                                                <div className="">
                                                                    {moment(up?.availableFrom).format(
                                                                        "DD-MM-YYYY"
                                                                    )}
                                                                </div>
                                                            )}
                                                    </td>
                                                    <td>
                                                        <i
                                                            className="icon-bin"
                                                            onClick={() => onRemove(up.unitId!)}
                                                        ></i>
                                                    </td>
                                                </tr>
                                            )
                                        )}
                                        {!showAddSingleOption && (
                                            <tr>
                                                <td colSpan={2}>
                                                    <button
                                                        type="button"
                                                        className="btn btn-link font-sm p-0 font-weight-semibold"
                                                        onClick={() => {
                                                            setSelectedOption([
                                                                {
                                                                    floorName: "",
                                                                    unitID: "",
                                                                },
                                                            ]);
                                                            setShowAddSingleOption(true);
                                                        }}
                                                    >
                                                        + add more
                                                    </button>
                                                </td>
                                                {selectedProperty?.length > 1 && (
                                                    <td colSpan={5} className="text-right">
                                                        {isMerging ? (
                                                            <span className="cursor-pointer p-0 m-0">
                                                                <Spinner height={40} width={40} />
                                                            </span>
                                                        ) : (
                                                            <button
                                                                type="button"
                                                                className="btn btn-link font-sm p-0 font-weight-semibold"
                                                                onClick={() => mergePropeties?.()}
                                                            >
                                                                Merge and Add to Shortlist
                                                            </button>
                                                        )}
                                                    </td>
                                                )}
                                            </tr>
                                        )}
                                    </thead>
                                </table>
                            )}
                            {showAddSingleOption && (
                                <div className="bg-gray-100 px-3 pb-1 pt-3 rounded">
                                    <div className="row px-1">
                                        <div className="col-md-6 col-12 font-sm mb-3">
                                            <div className="form-group font-weight-semibold mb-0 custom-dropdown">
                                                <label
                                                    htmlFor=""
                                                    className="font-sm text-uppercase"
                                                >
                                                    Floor
                                                </label>
                                                <DropdownList
                                                    data={floorData}
                                                    textField={"label"}
                                                    valueField={"value"}
                                                    placeholder={"Select"}
                                                    itemComponent={renderSelectItems}
                                                    onChange={(val) => {
                                                        setSelectedOption({
                                                            floorName: val.value,
                                                            unitID: "",
                                                        });
                                                        // onChange(val.value);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-12 font-sm mb-3">
                                            <div className="form-group font-weight-semibold mb-0 custom-dropdown">
                                                <label
                                                    htmlFor=""
                                                    className="font-sm text-uppercase"
                                                >
                                                    Unit Area
                                                </label>
                                                <DropdownList
                                                    data={unitData}
                                                    textField={"label"}
                                                    valueField={"value"}
                                                    placeholder={"Select"}
                                                    itemComponent={renderSelectItems}
                                                    onChange={(val) => {
                                                        setSelectedOption({
                                                            floorName: selectedOption.floorName,
                                                            unitID: val.value,
                                                            unitData: project?.unitDetails?.find(
                                                                (u) => u.unitID === val.value
                                                            ),
                                                        });
                                                        // onChange(val.value);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-12 d-flex justify-content-end text-decoration-underline text-primary mb-4">
                                            {!!selectedOption?.unitID && (
                                                <a
                                                    className="cursor-pointer text-primary font-sm  text-nowrap"
                                                    onClick={handleClickpopup}
                                                >
                                                    Split Unit
                                                </a>
                                            )}
                                            {isShown && (
                                                <SplitMerge
                                                    setIsShown={setIsShown}
                                                    selectedOption={selectedOption}
                                                    splitUnitsAndProperties={
                                                        splitUnitsAndProperties
                                                    }
                                                    isSpliting={isSpliting}
                                                />
                                            )}
                                        </div>
                                        <div className="col-12 font-sm mb-3 d-flex justify-content-end">
                                            <button
                                                className="btn bg-primary text-white px-4 font-normal font-weight-bold py-1 rounded"
                                                style={{ height: "32px" }}
                                                disabled={!selectedOption.unitID}
                                                type="button"
                                                onClick={() => {
                                                    onSelect(selectedOption.unitID);
                                                    setShowAddSingleOption(false);
                                                }}
                                            >
                                                Add Option
                                            </button>

                                        </div>
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
